var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2716_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0845 10.8333V14.6254C22.0845 15.0158 22.401 15.3323 22.7915 15.3323C23.1819 15.3323 23.4984 15.0158 23.4984 14.6254V9.12683C23.4984 8.73639 23.1819 8.41988 22.7915 8.41988H17.2929C16.9025 8.41988 16.586 8.73639 16.586 9.12683C16.586 9.51728 16.9025 9.83379 17.2929 9.83379H21.0844L15.2217 15.6965C14.9456 15.9726 14.9456 16.4202 15.2217 16.6963C15.4978 16.9724 15.9454 16.9724 16.2215 16.6963L22.0845 10.8333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4016 11.0121C10.4905 11.0121 9.75205 11.7505 9.75205 12.6616V20.5167C9.75205 21.4279 10.4905 22.1663 11.4016 22.1663H19.2567C20.1678 22.1663 20.9063 21.4279 20.9063 20.5167V16.5892C20.9063 16.1987 21.2228 15.8822 21.6132 15.8822C22.0037 15.8822 22.3202 16.1987 22.3202 16.5892V20.5167C22.3202 22.2087 20.9487 23.5802 19.2567 23.5802H11.4016C9.70959 23.5802 8.33813 22.2087 8.33813 20.5167V12.6616C8.33813 10.9696 9.70959 9.59814 11.4016 9.59814H15.3292C15.7196 9.59814 16.0361 9.91465 16.0361 10.3051C16.0361 10.6955 15.7196 11.0121 15.3292 11.0121H11.4016Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2716_925"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.836426 16C0.836426 7.67058 7.58876 0.918243 15.9182 0.918243C24.2476 0.918243 30.9999 7.67058 30.9999 16C30.9999 24.3294 24.2476 31.0818 15.9182 31.0818C7.58876 31.0818 0.836426 24.3294 0.836426 16Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.afc16a69e0bba5fd7e2a48be41c3b86b.svg";
export { ForwardRef as ReactComponent };